import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ProfileService } from 'core/services/profile.service';

@Directive({
  selector: '[lmsProfileGuard]'
})
export class ProfileGuardDirective {
  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainer: ViewContainerRef,
    public profileService: ProfileService
  ) {}

  @Input() set lmsProfileGuard(action: string) {
    if (action === 'distributor.edit') {
      // FIXME I think this is for image-selector and could be made better
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      if (this.profileService.canExecute(action)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }
  }
}
